// routing
import Routes from 'routes';

// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
// import RTLLayout from 'ui-component/RTLLayout';
import ThemeCustomization from 'themes';

// auth provider
import AuthProvider from 'contexts/AuthContext';
import { GlobalStateProvider } from 'contexts/GlobalStateProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import ErrorBountry from 'components/error/ErrorBountry';
import { ConfirmationProvider } from 'components/reusable/ConfirmationModal';
// import GlobalLoader from 'components/common/GlobalLoader';

// eslint-disable-next-line import/no-extraneous-dependencies
import 'bootstrap/dist/css/bootstrap.min.css';
import IdleDetector from 'components/common/IdleDetector';

import { SnackbarProvider } from 'notistack';
import Snackbar from 'ui-component/extended/Snackbar';
import CacheBuster from 'CacheBuster';

// ==============================|| APP ||============================== //

const App = () => (
    <ErrorBountry>
        <ThemeCustomization>
            <ConfirmationProvider>
                <IdleDetector>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <GlobalStateProvider>
                            <Locales>
                                <NavigationScroll>
                                    <AuthProvider>
                                        <SnackbarProvider
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'right'
                                            }}
                                        >
                                            {/* <CacheBuster>
                                                {({ loading, isLatestVersion, refreshCacheAndReload }) => {
                                                    if (loading) return null;
                                                    if (!loading && !isLatestVersion) {
                                                        // You can decide how and when you want to force reload
                                                        refreshCacheAndReload();
                                                    } */}
                                            <Routes />;
                                            {/* }}
                                            </CacheBuster> */}
                                            <Snackbar />
                                        </SnackbarProvider>
                                    </AuthProvider>
                                </NavigationScroll>
                            </Locales>
                        </GlobalStateProvider>
                    </LocalizationProvider>
                </IdleDetector>
                {/* <GlobalLoader /> */}
            </ConfirmationProvider>
        </ThemeCustomization>
    </ErrorBountry>
);

export default App;
